import type z from 'zod/v4'
import { index, integer, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

export const Grade = pgTable(
  'grade',
  {
    id: uuid().notNull().primaryKey(),
    name: text().notNull(),
    description: text(),
    order: integer().notNull(),
    legacyCategoryId: integer(),
    legacyNeonTagId: uuid(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
    createdAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
  },
  (columns) => [
    index('grade_name_idx').on(columns.name),
    index('grade_updated_at_idx').on(columns.updatedAt),
    index('grade_created_at_idx').on(columns.createdAt),
  ],
)

export const InsertGradeSchema = createInsertSchema(Grade)
export const UpdateGradeSchema = createUpdateSchema(Grade)
  .omit({ id: true, legacyCategoryId: true, legacyNeonTagId: true })
  .partial()
export const SelectGradeSchema = createSelectSchema(Grade)

export type InsertGrade = typeof Grade.$inferInsert
export type UpdateGrade = z.infer<typeof UpdateGradeSchema>
export type SelectGrade = typeof Grade.$inferSelect
